import { Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer} from 'react-toastify';
import { DetectProvider } from "./contexts/DetectContext";
import store from "./store";
import HomePage from "./pages/HomePage";
import ImageDetection from "./pages/ImageDetection";
import LiveDetection from "./pages/LiveDetection";
import DataCollection from "./pages/DataCollection";
import Login from "./pages/Login";
import PrivateRoute from "./components/PrivateRoute";
import MapResults from "./pages/MapResults";


function App() {
  return (
    <Provider store={store}>
      <DetectProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute validRole={["admin", "manager", "user"]}>
                <HomePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/image-detection"
            element={
              <PrivateRoute validRole={["admin"]}>
                <ImageDetection />
              </PrivateRoute>
            }
          />
          <Route
            path="/live-detection"
            element={
              <PrivateRoute validRole={["admin"]}>
                <LiveDetection />
              </PrivateRoute>
            }
          />
          <Route
            path="/data-collection"
            element={
              <PrivateRoute validRole={["admin", "manager", "user"]}>
                <DataCollection />
              </PrivateRoute>
            }
          />
          <Route
            path="/map-results"
            element={
              <PrivateRoute validRole={["admin","manager"]}>
                <MapResults />
              </PrivateRoute>
            }
          />
        </Routes>
        <ToastContainer />
      </DetectProvider>
    </Provider>
  );
}

export default App;
